import React from 'react';
import { Outlet } from 'react-router-dom';

export default function AppLayout({ title, breadcrumb, actions, children }) {
  // MainLayout already handles the sidebar and top header
  return (
    <div className="finance-app-layout">
      {/* If there are specific finance actions, we could render them here, 
          but for now we just pass through to Outlet since MainLayout is the shell */}
      {children ?? <Outlet />}
    </div>
  );
}
